"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _combineStreams = _interopRequireDefault(require("../util/combine-streams"));

var _constants = require("../util/constants");

var _devices = _interopRequireDefault(require("./devices"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _link = _interopRequireDefault(require("./link"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

var _webhooks = _interopRequireDefault(require("./webhooks"));

var _pubsubs = _interopRequireDefault(require("./pubsubs"));

var _applicationPackages = _interopRequireDefault(require("./application-packages"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var IS = _constants.STACK_COMPONENTS_MAP.is,
    AS = _constants.STACK_COMPONENTS_MAP.as,
    NS = _constants.STACK_COMPONENTS_MAP.ns,
    JS = _constants.STACK_COMPONENTS_MAP.js,
    DTC = _constants.STACK_COMPONENTS_MAP.dtc;
/**
 * Applications Class provides an abstraction on all applications and manages
 * data handling from different sources. It exposes an API to easily work with
 * application data.
 *
 * @param {object} api - The connector to be used by the service.
 * @param {object} config - The configuration for the service.
 * @param {string} config.defaultUserId - The users identifier to be used in
 * user related requests.
 * @param {boolean} config.proxy - The flag to identify if the results
 * should be proxied with the wrapper objects.
 */

var Applications = /*#__PURE__*/function () {
  function Applications(api, _ref) {
    var defaultUserId = _ref.defaultUserId,
        stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, Applications);
    this._defaultUserId = defaultUserId;
    this._api = api;
    this._stackConfig = stackConfig;
    this.ApiKeys = new _apiKeys["default"](api.ApplicationAccess, {
      parentRoutes: {
        get: 'application_ids.application_id',
        list: 'application_ids.application_id',
        create: 'application_ids.application_id',
        update: 'application_ids.application_id'
      }
    });
    this.Link = new _link["default"](api.As);
    this.Devices = new _devices["default"](api, {
      stackConfig: stackConfig
    });
    this.Collaborators = new _collaborators["default"](api.ApplicationAccess, {
      parentRoutes: {
        get: 'application_ids.application_id',
        list: 'application_ids.application_id',
        set: 'application_ids.application_id'
      }
    });
    this.Webhooks = new _webhooks["default"](api.ApplicationWebhookRegistry);
    this.PubSubs = new _pubsubs["default"](api.ApplicationPubSubRegistry);
    this.Packages = new _applicationPackages["default"](api.ApplicationPackageRegistry);
  } // Retrieval.


  (0, _createClass2["default"])(Applications, [{
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.ApplicationRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.ApplicationRegistry.Get({
                  routeParams: {
                    'application_ids.application_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].unwrapApplication(response));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "getByOrganization",
    value: function () {
      var _getByOrganization = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(organizationId) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = this._api.ApplicationRegistry.List({
                  routeParams: {
                    'collaborator.organization_ids.organization_id': organizationId
                  }
                });
                return _context3.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getByOrganization(_x5) {
        return _getByOrganization.apply(this, arguments);
      }

      return getByOrganization;
    }()
  }, {
    key: "getByCollaborator",
    value: function () {
      var _getByCollaborator = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userId) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                response = this._api.ApplicationRegistry.List({
                  routeParams: {
                    'collaborator.user_ids.user_id': userId
                  }
                });
                return _context4.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getByCollaborator(_x6) {
        return _getByCollaborator.apply(this, arguments);
      }

      return getByCollaborator;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.EntityRegistrySearch.SearchApplications(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function search(_x7, _x8) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, patch) {
        var mask,
            response,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                mask = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.ApplicationRegistry.UpdateAllowedFieldMaskPaths);
                _context6.next = 3;
                return this._api.ApplicationRegistry.Update({
                  routeParams: {
                    'application.ids.application_id': id
                  }
                }, {
                  application: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].unwrapApplication(response));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateById(_x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var ownerId,
            application,
            isUserOwner,
            routeParams,
            response,
            _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                ownerId = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : this._defaultUserId;
                application = _args7.length > 1 ? _args7[1] : undefined;
                isUserOwner = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context7.next = 6;
                return this._api.ApplicationRegistry.Create({
                  routeParams: routeParams
                }, {
                  application: application
                });

              case 6:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].unwrapApplication(response));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(applicationId) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.ApplicationRegistry.Delete({
                  routeParams: {
                    application_id: applicationId
                  }
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteById(_x11) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(id) {
        var response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.ApplicationRegistry.Purge({
                  routeParams: {
                    application_id: id
                  }
                });

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function purgeById(_x12) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(applicationId) {
        var result;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.ApplicationAccess.ListRights({
                  routeParams: {
                    application_id: applicationId
                  }
                });

              case 2:
                result = _context10.sent;
                return _context10.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getRightsById(_x13) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }()
  }, {
    key: "getMqttConnectionInfo",
    value: function () {
      var _getMqttConnectionInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(applicationId) {
        var response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._api.AppAs.GetMQTTConnectionInfo({
                  routeParams: {
                    application_id: applicationId
                  }
                });

              case 2:
                response = _context11.sent;
                return _context11.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getMqttConnectionInfo(_x14) {
        return _getMqttConnectionInfo.apply(this, arguments);
      }

      return getMqttConnectionInfo;
    }() // Events Stream

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(identifiers, tail, after) {
        var _this = this;

        var payload, distinctComponents, streams;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      application_ids: {
                        application_id: id
                      }
                    };
                  }),
                  tail: tail,
                  after: after
                }; // Event streams can come from multiple stack components. It is necessary to
                // check for stack components on different hosts and open distinct stream
                // connections for any distinct host if need be.

                distinctComponents = this._stackConfig.getComponentsWithDistinctBaseUrls([IS, JS, NS, AS, DTC]);
                streams = distinctComponents.map(function (component) {
                  return _this._api.Events.Stream({
                    component: component
                  }, payload);
                }); // Combine all stream sources to one subscription generator.

                return _context12.abrupt("return", (0, _combineStreams["default"])(streams));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function openStream(_x15, _x16, _x17) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }()
  }]);
  return Applications;
}();

var _default = Applications;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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